// extracted by mini-css-extract-plugin
export default {"container":"MainContent-module__container--NyRpm","inner":"MainContent-module__inner--qD0Pb","compact":"MainContent-module__compact--S3brA"};